export const environment = {
  production: true,
  imgFxActive: true,
  imgFxDomain: 'https://icid.imgfx.net/{mode}/size-{size}/',

  // imagePath: 'https://localhost:7012/upload/media/',
  // apiDomain: 'https://localhost:44383/',

  imagePath: 'https://api.icid.se/upload/media/',
  apiDomain: 'https://api.icid.se/',
  // apiDomain: 'https://localhost:44383/',

  // imagePath: 'http://localhost:5192/upload/media/',
  // apiDomain: 'http://localhost:5192/',

  // staticContent: 'E:/IcanIdo',
  staticContent: 'C:/StaticResources/IcId',
};
